<template>
  <div class="home">
    <b-container>
      <h1 class="titre_home">Ligne régulière<br/>Château-Salins - Metz</h1>
      <span class="possibilite_express">Possibilité de rejoindre rapidement Metz ou Château-Salins via notre ligne express</span>

      <h2 class="accroche">
        Bienvenue sur le site de votre ligne Château-Salins - Metz : retrouvez les horaires et informations, vérifiez
        les prochains passages en temps réel et réservez votre trajet !
      </h2>
    </b-container>

    <b-container>
      <img class="thermometre_desktop" src="../assets/thermometre-desktop.png" alt="parcours Metz express desktop"/>
      <img class="thermometre_mobile" src="../assets/thermometre-mobile.png" alt="parcours Metz express mobile"/>
    </b-container>

    <b-container>
      <div class="grille row">
        <div class="col-sm-6 col-12">
          <b-btn class="bloc_vert" :to="{name:'Horaires'}">
            <i class="icone far fa-clock fa-4x"></i><br/>
            <span class="text_bloc">Consultez les horaires</span>
          </b-btn>
        </div>
        <div class="col-sm-6 col-12">
          <b-btn class="bloc_bleu" :to="{name:'Communes'}">
            <i class="icone fas fa-road fa-4x"></i><br/>
            <span class="text_bloc">Prochains passages</span>
          </b-btn>
        </div>
        <div class="col-sm-6 col-12">
          <b-btn class="bloc_bleu" :to="{name:'Reserver'}">
            <i class="icone fas fa-book-open fa-4x"></i><br/>
            <span class="text_bloc">Réservez votre trajet</span>
          </b-btn>
        </div>
        <div class="col-sm-6 col-12">
          <b-btn class="bloc_vert" :to="{name:'Tarifs'}">
            <i class="icone far fa-money-bill-alt fa-4x"></i><br/>
            <span class="text_bloc">Grilles tarifaires</span>
          </b-btn>
        </div>
        <div class="col-sm-6 col-12">
          <b-btn class="bloc_vert" :to="{name:'RecupCarte'}">
            <i class="icone far fa-id-card fa-4x"></i><br/>
            <span class="text_bloc">Récupérez votre carte scolaire</span>
          </b-btn>
        </div>
        <div class="col-sm-6 col-12">
          <b-btn class="bloc_bleu" :to="{name:'Contact'}">
            <i class="icone fas fa-address-card fa-4x"></i><br/>
            <span class="text_bloc">Contactez-nous</span>
          </b-btn>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    name: 'Home'
  }
</script>

<style lang="scss">
@import "src/sass/app";

.home {
  margin-top: 3rem;
  text-align: center;

  .titre_home {
    color: $firstcolor;
    font-family: $titlefont;
    font-size: 50px;
    font-weight: bold;
  }

  .possibilite_express {
    color: $firstcolor;
    font-family: $textfont;
    font-size: 20px;
  }

  .accroche {
    margin: 2rem 0;
    font-size: 25px;
    text-align: justify;
    color: $annexecolor;
    font-family: $textfont;
  }

  .thermometre_desktop {
    margin: 2rem auto;
    width: 100%;
    @include media-breakpoint-down(sm) {
      display: none;
    }
  }

  .thermometre_mobile {
    margin: 2rem auto;
    width: 100%;
    @include media-breakpoint-up(md) {
      display: none;
    }
  }

  .grille {
    margin-top: 2rem;
    display: flex;

    .bloc_vert {
      @include blocHome;
      border: 2px solid $firstcolor;
      background-color: white;
      color: $firstcolor;
    }

    .bloc_vert:hover {
      background-color: $firstcolor;
      color: white;
    }

    .bloc_bleu {
      @include blocHome;
      border: 2px solid $secondcolor;
      background-color: white;
      color: $secondcolor;
    }

    .bloc_bleu:hover {
      background-color: $secondcolor;
      color: white;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue